<template>
    <div class="relative">
        <div class="absolute -mt-1 md:-mt-2 pl-1 md:pl-3">
            <i class="text-sm text-green-warm-500 fas fa-equals"></i>
        </div>

        <form-row title="Listing Net Fee"
            :no_border="true"
            class="mt-6 md:-mt-2 mb-6"
            label_class="ml-8 md:ml-0 md:mt-4"
        >
            <div class="flex flex-wrap items-center -mt-6 md:mt-0">
                <div class="w-3/5 sm:w-36 mr-4">
                    <input-money
                        name="list_side_list_net_sales_fee"
                        label=" "
                        :value="net_fee"
                        :read_only="true"
                        tabindex="-1"
                    />
                </div>

                <div class="md:w-18 w-2/5">
                    <input-percent
                        label="% Split"
                        name="list_side_percent_split"
                        :value="value"
                        @input="$emit('input', $event)"
                        :read_only="read_only"
                    />
                </div>

                <div class="w-1/4 flex sm:w-auto items-center justify-center mt-4 px-6">
                    <i class="text-sm text-green-warm-500 fas fa-equals"></i>
                </div>

                <div class="w-3/4 sm:w-36 mt-4 sm:mt-0 sm:ml-auto">
                    <input-money
                        label="Net to Agent"
                        name="list_side_net_to_agent"
                        :value="net_to_agent"
                        :read_only="true"
                        tabindex="-1"
                    />
                </div>
            </div>
        </form-row>

        <div class="border-b border-gray-400 md:ml-46 mb-6"></div>
    </div>
</template>

<script>
export default {
    props: {
        value: { default: null },
        net_fee: { default: null },
        net_to_agent: { default: null },
        read_only: { default: false },
    },
}
</script>
